import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';

export const permissionGuard: CanActivateFn = async (route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const user = await auth.ensureCurrentUser();

  if (!user) {
    return router.createUrlTree(['/login'], {
      queryParams: { returnUrl: state.url },
    });
  }

  const requiredPermission = route.data['requiredPermission'] as string | undefined;
  const anyPermissions = route.data['anyPermissions'] as readonly string[] | undefined;
  const permitted = requiredPermission
    ? auth.hasPermission(requiredPermission)
    : anyPermissions
      ? auth.hasAnyPermission(anyPermissions)
      : true;

  return permitted || router.createUrlTree(['/forbidden']);
};
